import axios from 'axios'
import {errorHandler, responseHandler} from './response.interceptor'
import {authHandler} from './auth.interceptor'
import {global} from '../utils/global'

class Http {
  interceptors (instance) {
    instance.interceptors.request.use(
      config => {
        authHandler(config)
        return config
      },
      error => {
        return Promise.reject(error)
      }
    )
    instance.interceptors.response.use(
      response => {
        responseHandler(response)
        return Promise.resolve(response.data)
      },
      error => {
        errorHandler(error)
        return Promise.reject(error)
      }
    )
  }

  getInsideConfig () {
    return {
      baseURL: global.BASE_URL,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }
  }

  get (url, params) {
    const config = {
      url: url,
      method: 'get',
      params: params
    }
    return this.request(config)
  }

  post (url, data, params) {
    const config = {
      url: url,
      method: 'post',
      data: data,
      params: params
    }
    return this.request(config)
  }

  getWithoutAuthorizationAndBaseURL (url, params) {
    const instance = axios.create()
    const option = {
      url: url,
      method: 'get',
      params: params,
      Authorization: '',
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }
    // const config = Object.assign({}, this.getInsideConfig(), option)
    return instance(option)
  }

  getWithoutAuthorization (url, params) {
    const instance = axios.create()
    const option = {
      url: url,
      method: 'get',
      params: params,
      Authorization: ''
    }
    const config = Object.assign({}, this.getInsideConfig(), option)
    return instance(config)
  }

  request (option) {
    const instance = axios.create()
    const config = Object.assign({}, this.getInsideConfig(), option)
    this.interceptors(instance)
    return instance(config)
  }
}
export default new Http()
